/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef, useContext } from "react";
import Navbar from "./Navbar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import GoSellElementsTrans from "../Pages/GoSell";
import { useHistory, Link } from "react-router-dom";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import Axios from "axios";
import LoaderAnimation from "./LoaderAnimation";




// Cookies functions
import { getCookie, setCookie, erase } from "../Functions/cookieFunction";
import { useTranslation, withTranslation } from "react-i18next";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));
function WalletTab() {
  const [value, setValue] = useState(0);
  const {t} = useTranslation();
  const childRef = useRef();
  const [success, setSuccess] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const classes = useStyles();
  const [tapId, setTapId] = useState("");
  const [payWithValue, setPayWithValue] = useState("KNET");
  const [paymentValue, setPaymentValue] = useState(1.5);
  const [inpValue, setInpValue] = useState(1.5);
  const [cardStatus, setCardStatus] = useState("");
  const [amount, setAmount] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [showCard, setShowCard] = useState(0)
  const [cardResponse, setCardResponse] = useState([]);
  const [cardData, setCardData] = useState([{}]);
  const [count, setCount] = useState(1)
  const [seeMore, setSeeMore] = useState(1)
  const [loading, setLoading] = useState(false)

  const handlePaymentChange = (e) => {
    setPayWithValue(e.target.value);
  };
  const handlePaymentValue = (e) => {
    setPaymentValue(parseFloat(e.target.value));
  };

  const history = useHistory();
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // let radioInput = document.querySelectorAll('input[name=selectPayment]')
  const handleInpValue = (e) => {
    isNaN(parseFloat(e.target.value))
      ? setInpValue(0)
      : setInpValue(parseFloat(e.target.value));
  };

  const getSaveCards = async () => {
    var credToken = getCookie("tokenAuth");
    if (credToken !== "" && credToken !== null) {
      try {
        const newReq = await Axios.get(
          `${process.env.REACT_APP_API3_URL}customer/get_card`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );
        setCardData(newReq.data.data);

        // console.log(cardData)
      } catch (e) {
        Promise.reject(e);
      }
    }
  };

  useEffect(() => {
    getSaveCards();
  }, [count]);

  useEffect(() => {
    getSaveCards();
  }, []);

  // Getting Tap ID From URL If it is present
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setTapId(urlParams.get("tap_id"));
  }, []);
  // Setting The Amount If Tap id is present and cookie is present
  useEffect(() => {
    const fetchStat = async () => {
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_PAY_URL}api/v2/charges/${tapId}`,
          {
            headers: {
              Authorization: "Bearer sk_test_TgNBsDQkcFh7HwfU08tSdjZz",
              // "Content-Type": "application/json",
            },
          }
        );
        setCardStatus(response.data.status);
        if (getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`)) {
          let newCookie = getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`);
          setAmount(newCookie.slice(process.env.REACT_APP_SECRET_KEY.length));
        }
      } catch (e) {
        Promise.reject(e);
      }
    };
    if (tapId !== null && tapId !== "") {
      fetchStat();
      // if (getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`)) {
      //     let newCookie = getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`);
      //     setAmount(newCookie.slice(process.env.REACT_APP_SECRET_KEY.length))
      // }
    }
  }, [tapId]);

  useEffect(() => {
    if (getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`)) {
      if (amount !== "") {
        // console.log('amount check ', amount)
        if (
          cardStatus !== undefined &&
          cardStatus !== "" &&
          cardStatus !== null
        ) {
          if (cardStatus == "CAPTURED") {
            depositAmount();
          } else {
            setAlertMessage({
              open: true,
              message: `Your transaction has been ${cardStatus}`,
              alertSuccess: false,
            });
            history.push("/wallet");
          }
        }
      }
    }
  }, [amount]);
  const depositAmount = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API3_URL}wallet/deposit-amount`,
        {
          amount: amount,
          user_id: appState.login,
        }
      );
      setButtonLoading(false);
      // console.log(response)
      appDispatch({ type: "UpdateProfile", profile: {...appState.profile, walletAmount: response.data.data.amount,} });

      appDispatch({
        type: "WalletInf",
        wallet: {
          ...appState.wallet,
          amount: response.data.data.amount,
        },
      });
      if (getCookie(`am_tr${process.env.REACT_APP_SECRET_KEY}`)) {
        erase(`am_tr${process.env.REACT_APP_SECRET_KEY}`);
      }

      setAlertMessage({
        open: true,
        message: `Your transaction has been ${cardStatus}`,
        alertSuccess: true,
      });
      history.push("/wallet");
    } catch (e) {
      Promise.reject(e);
    }
  };
  useEffect(() => {
    setInpValue(paymentValue);
  }, [paymentValue]);
  useEffect(() => {
    setTimeout(() => {
      setAlertMessage({ open: false, message: "", alertSuccess: false });
    }, 8000);
  }, [alertMessage.open]);
  const handleKnet = () => {
    if (inpValue < 1.5) {
      setAlertMessage({
        open: true,
        message: `Amount should be greater than 1.5 ${t("KWD")}`,
        alertSuccess: false,
      });
      return;
    }
    childRef.current.payWithKnet();
  };
  const handleCard = () => {
    if (inpValue < 1.5) {
      setAlertMessage({
        open: true,
        message: `Amount should be greater than 1.5 ${t("KWD")}`,
        alertSuccess: false,
      });
      return;
    }
    setCount(count+1
        )
    childRef.current.submitRequest();
  };
  // if(isLoading) return <div className={classes.root}><CircularProgress /></div>
  if (!appState.loggedIn) {
    history.push("/");
  }

  const topUp = async () => {
    const token = await {
      headers: {
        Authorization: `Bearer ${appState.token}`,
      },
    };

    Axios.post(
      `${process.env.REACT_APP_API3_URL}customer/topup`,
      {
        amount: inpValue,
        payment_source: payWithValue,
        token: tapId ? tapId : null,
      },
      token
    ).then((response) => {
      if (response.data.success == true) {
        
        const win = window.open(`${response.data.data.url}`, "_self");
        win.focus();
        
        setAlertMessage({
          open: true,
          message: response.data.message,
          alertSuccess: true,
        });
      } else if (response.data.success == false) {

        if (typeof response.data.data == "string") {
          setAlertMessage({
            open: true,
            message: response.data.data,
            alertSuccess: false,
          });
          setLoading(false)
        } else {
          setAlertMessage({
            open: true,
            message: response.data.data[0],
            alertSuccess: false,
          });
          setLoading(false)
        }

        //  setPLoading(false);
      }
    });
  };
  const handleSubmit = (event) => {
    setLoading(true)
    event.preventDefault();
    if (
      payWithValue != undefined &&
      payWithValue != "" &&
      payWithValue != null
    ) {
      if (payWithValue == "knet") {
        topUp();
      } else if (payWithValue == "card") {
        if (tapId != undefined && tapId != "" && tapId != null) {
          topUp();
        } else {
          childRef.current.submitRequest();
        }
      }
    } else {
      setAlertMessage({
        open: true,
        message: "Please select any payment method!",
        alertSuccess: false,
      });
      setLoading(false)
    }
  };

  useEffect(() => {
    if (tapId != "" && tapId != undefined) {
      topUp();
    }
  }, [tapId]);
  const handleManageCard = () => {
    setSaveCard(!saveCard);
    setPayWithValue("saveCard");
  };
  if (loading)
    return (
      <div className={classes.root}>
        {" "}
        <LoaderAnimation />{" "}
      </div>
    );
  return (
    <>
      <section id="walletBodytab" className="px-5">
        {/* <Navbar dataAttr="" handleChange={handleChange} /> */}
        {/* bannerSection */}
        <div className={`bannerSection`}>
          {/* innerBanner */}
          <div className="innerBanner">
            {/* bannerImg */}
            <div
              className="bannerImg"
            >
              <div className="bannerWalletContent">
               
                <div
                  className={`row m-0 d-flex justify-content-between align-items-center mt-4 `}
                >
                  
                  <div
                    className={`walletAmount_Tab ${
                      appState.langValue === "ar"
                        ? "d-flex align-items-start flex-column"
                        : "d-flex flex-column"
                    }`}
                  >
                    <p className=" mx-3"> Balance</p>
                    <h3 className="mx-3">
                      <strong>
                        {appState.profile.walletAmount
                          ? parseFloat(appState.profile.walletAmount)
                          : "0"}
                      </strong>
                      <span className="small ml-2">{t("KWD")}</span>
                    </h3>
                  </div>
                  
                  <div className="walletAmount_Tab d-flex align-items-center mt-3">
                    <span className="">
                      
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}cashbackicon.png`}
                        alt=""
                      />
                      
                    </span>
                    <span className="mx-3">
                      {/* <strong>{appState.profile.walletAmount ? parseFloat(appState.profile.walletAmount) : '0'}</strong> */}
                      <span>
                        2,14
                        <span className="small ml-2">{t("KWD")}</span>
                        <h5>Cashback</h5>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="walletContent px-3">
          <div className="amountFieldContainer">
            <div className="row m-0 align-items-center WalletRow">
              <div className="col-md-3 p-0 my-2    ">
                <h5 className={`d-flex`}>
                  {/* <CreditCardIcon />  */}
                  Amount
                </h5>
              </div>
              <div className="col-md-9 p-0">
                <div className="WalletInfomration walletAmount">
                  <OutlinedInput
                    id="standard-adornment-weight"
                    //   value={amount}
                    //   onChange={handleAmount}
                    // onClick={amountField}
                    onChange={(e) => handleInpValue(e)}
                    value={inpValue}
                    type="number"
                    className="border-0 w-100 text-center amount-field "
                    endAdornment={
                      <InputAdornment position="end" className="text-muted">
                        {t("KWD")}
                      </InputAdornment>
                    }
                  />
                </div>
                {/* <span className="text-secondary"><strong>{t("KWD")}</strong></span> */}
              </div>
            </div>
          </div>
          
          <p className="pt-2 text-muted d-flex">Or quickly select amount</p>
          
          <div className="">
            <div
              id="menuContainer"
              role="group"
              className="row m-0 menuContainer .scrollbar-hidden btn-group selectPaymentRow"
              onChange={(e) => handlePaymentValue(e)}
            >
              
              <div className="d-flex">
                <div className="col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="10"
                      name="selectPayment"
                      id="paymentTen"
                    />
                    <label htmlFor="paymentTen">
                      <span>
                        <strong> +10</strong>
                        <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="20"
                      name="selectPayment"
                      id="paymentTwenty"
                    />
                    <label htmlFor="paymentTwenty">
                      <span>
                        <strong>+20</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer ">
                    <input
                      type="radio"
                      value="30"
                      name="selectPayment"
                      id="paymentThirty"
                    />
                    <label htmlFor="paymentThirty">
                      <span>
                        <strong>+30</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className=" col-lg-2 col-4 menu-inner-container ">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="40"
                      name="selectPayment"
                      id="paymentFourty"
                    />
                    <label htmlFor="paymentFourty">
                      <span>
                        <strong>+40</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="50"
                      name="selectPayment"
                      id="paymentFifty"
                    />
                    <label htmlFor="paymentFifty">
                      <span>
                        <strong>+50</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className=" col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="60"
                      name="selectPayment"
                      id="paymentSixty"
                    />
                    <label htmlFor="paymentSixty">
                      <span>
                        <strong>+60</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
                <div className=" col-lg-2 col-4 menu-inner-container">
                  <div className="paymentContainer">
                    <input
                      type="radio"
                      value="70"
                      name="selectPayment"
                      id="paymentSeventy"
                    />
                    <label htmlFor="paymentSeventy">
                      <span>
                        <strong>+70</strong> <span className="KD"> {t("KWD")}</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          <div className="row m-0 mt-4">
               
                <div className="payWith col-md-12 px-1">
                
                  <span className="d-flex align-items-center justify-content-between">
                    <h5 className="text-secondary px-3 d-flex">Pay With</h5>
                    <Button
                      variant="contained"
                      color="primary"
                      className={`${buttonClassname} bg-primary  `}
                      // disabled={buttonLoading}
                      onClick={handleManageCard}
                    >
                      Manage Cards
                    </Button>
                  </span>
                    
                  {saveCard ? (
                    <>
                      <GoSellElementsTrans
                        setTapId={setTapId}
                        ref={childRef}
                        setCardStatus={setCardStatus}
                        payWithValue={payWithValue}
                        setCardResponse={setCardResponse}
                        setAlertMessage={setAlertMessage}
                        setAmount={setAmount}
                        setButtonLoading={setButtonLoading}
                        inpValue={inpValue}
                        setSaveCard={setSaveCard}
                      />

                      <div
                        className={`${classes.wrapper} w-100 d-flex justify-content-center`}
                      >
                        <Button
                          variant="contained"
                          disabled={inpValue < 1.5}
                          onClick={handleCard}
                          color="primary"
                          className={`${buttonClassname} bg-primary w-50 d-flex align-items-center justify-content-center`}
                          // disabled={buttonLoading}
                        >
                          {buttonLoading ? "Rendring" : "+ Add Card"}
                        </Button>
                        {buttonLoading && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div
                    className="row m-0 mt-4"
                    onChange={(e) => handlePaymentChange(e)}
                  >
                    {appState.cardList != null
                      ? appState.cardList.slice(0, seeMore).map((val, ind) => {
                          return (
                            
                            <div className="px-2">
                              <div className="paymentContainer">
                                <input
                                  type="radio"
                                  checked={payWithValue === "val.type"}
                                  value="Master"
                                  name="paymentMethod"
                                  id="paymentMaster"
                                />
                                <label htmlFor="paymentMaster">
                                  <div className="payment-method">
                                    <span className="px-4">
                                      <img
                                        src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                        alt=""
                                        width="30"
                                      />
                                    </span>
                                    {/* <span className="px-4 ">
                                      <h4 className="mt-2 text-capitalize">
                                        {val.type}
                                        <p className="text-muted">
                                          {" "}
                                          **** **** **** {val.last_four}
                                        </p>
                                      </h4>
                                    </span> */}
                                  </div>
                                </label>
                              </div>
                            </div>
                            
                          );
                        })
                      : ""}
                    {/* button for view more save cards */}
                    <div className="col-12 d-flex justify-content-end mb-2">
                      <Button
                        variant="text"
                        onClick={() => {
                          seeMore == 1
                            ? setSeeMore(appState.cardList.length)
                            : setSeeMore(1);
                        }}
                      >
                        {" "}
                        {seeMore == 1 ? "See More" : "See Less"}{" "}
                      </Button>
                    </div>
                    <div> </div>  
                        
                    <div className="px-2">
                      <div className="paymentContainer">
                        <input
                          type="radio"
                          checked={payWithValue === "knet"}
                          id="paymentKnet"
                          value="knet"
                          name="paymentMethod"
                        />
                        <label htmlFor="paymentKnet">
                          <div className="payment-method">
                            <span className="px-4">
                              <img
                                src={`${process.env.REACT_APP_IMAGE_URL}Knet.png`}
                                alt=""
                                width="30"
                              />
                            </span>
                            {/* <span className="px-4">
                              <h4 className="mt-2">Knet</h4>
                            </span> */}
                          </div>
                        </label>
                      </div>
                    </div>
                    
                      
                    <div className="px-2">
                      <div className="paymentContainer">
                        <input
                          type="radio"
                          checked={payWithValue === "card"}
                          id="paymentCard"
                          value="card"
                          name="paymentMethod"
                        />
                        <label htmlFor="paymentCard">
                          <div className="payment-method">
                            <span className="px-4">
                              <img
                                src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                alt=""
                                width="30"
                              />
                            </span>
                            {/* <span className="px-4">
                              <h4 className="mt-2">Card</h4>
                            </span> */}
                          </div>
                        </label>
                      </div>
                    </div>
                    
                    <div className="text-center ml-auto mt-4">
                  <Button
                    variant="contained"
                    disabled={buttonLoading}
                    // type="submit"
                    onClick={handleSubmit}
                    className=" bg-primary "
                  >
                    {buttonLoading ? "Processing" : <>PROCEED NOW <i className="fa fa-arrow-right pl-2" aria-hidden="true"></i> </>} 
                  </Button>
                  {buttonLoading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                  <span>
</span>
                </div>
            
                  </div>
               
                </div>

                {payWithValue == "card" ? (
                  <div className="col-6"  >
                    <GoSellElementsTrans
                      ref={childRef}
                      inpValue={inpValue}
                      setTapId={setTapId}
                      payWithValue={payWithValue}
                      setButtonLoading={setButtonLoading}
                    />
                  </div>
                ) : (
                  ""
                )}

             
         
              </div>

        
        </div>
      </section>
    </>
  );
}

export default withTranslation() (WalletTab) ;
